export default "__VITE_ASSET__CaABA4i7__"